import React from 'react';

import { CalendarToday as CalendarTodayIcon } from '@mui/icons-material';
import { Button, ButtonProps } from '@mui/material';
import {
  DatePicker,
  DatePickerFieldProps,
  DatePickerProps,
  usePickerContext,
} from '@mui/x-date-pickers';

import { DEFAULT_DATE_FORMAT } from '@clearverify/constants';

export type ButtonDatePickerProps = Omit<
  DatePickerProps,
  'open' | 'onOpen' | 'onClose' | 'label'
> & {
  buttonProps?: ButtonProps;
};

export const ButtonDatePicker: React.FC<ButtonDatePickerProps> = ({
  slots,
  slotProps,
  buttonProps,
  ...restProps
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <DatePicker
      slots={{ field: ButtonField, ...slots }}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      slotProps={{ field: { buttonProps } as any, ...slotProps }}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      {...restProps}
    />
  );
};

interface ButtonFieldProps extends DatePickerFieldProps {
  buttonProps?: ButtonProps;
}

const ButtonField: React.FC<ButtonFieldProps> = ({ id, buttonProps = {} }) => {
  const { triggerRef, setOpen, value, fieldFormat, disabled } = usePickerContext();

  return (
    <Button
      variant="text"
      id={id}
      ref={triggerRef}
      disabled={disabled}
      onClick={() => setOpen?.(prev => !prev)}
      endIcon={<CalendarTodayIcon fontSize="small" />}
      {...buttonProps}
    >
      {value ? value.toFormat(fieldFormat || DEFAULT_DATE_FORMAT) : 'Pick a date'}
    </Button>
  );
};
